export enum EMenuType {
  BASIC,
  COMPLEX
}

export enum EAssessmentsViewType {
  TABLE,
  RIBBON,
}

export enum ERoles {
  Admin = 'administrator',
  User = 'user',
  LicensedUser = 'licensed_user',
  OrgOwner = 'org_owner',
  CohortOwner = 'cohort_owner',
  Assessor = 'assessor',
  AssessmentOwner = 'assessment_owner'
}